import React from 'react'
import { useFirestore, useFirestoreCollectionData } from 'reactfire';
import { collection, query, deleteDoc, doc } from 'firebase/firestore';

import TableHeader from '../components/header.table';
import AdvertisementTable from '../components/advertisement.table';

const Advertisement = () => {
  const db = useFirestore();
  const advertisementsCollection = collection(db, 'advertisement')
  const advertisementsQuery = query(advertisementsCollection)

  const { status, data: advertisement } = useFirestoreCollectionData(advertisementsQuery, { idField: 'id' })

  const deleteAd = async (ad) => {
    await deleteDoc(doc(db, "advertisement", ad.id))
  }

  return (
    <>
      <TableHeader title="Publicidad" path="./create" />
      <AdvertisementTable data={advertisement} loading={status==="loading"} onDelete={deleteAd} />
    </>
  )
}

export default Advertisement